import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthenticationService } from './services';
import { AppRoutingModule } from './routing/app.routing';
import { AppStoreModule } from './store/app.store';
import { ToastService } from './services/toast.service';
import { TokenStorageService } from './services/token-storage.service';
import { AuthorizationInterceptor, authorizationInterceptorProviders } from './interceptors/authorization.interceptor';
import { BaseModalService } from './services/base-modal.service';
import { AuthenticationErrorInterceptor } from './interceptors/authenticationError.interceptor';
import {CommonModule} from "@angular/common";


@NgModule({ declarations: [],
    exports: [
        AppRoutingModule,
        AppStoreModule
    ], imports: [BrowserModule,
        AppRoutingModule,
        AppStoreModule,
        CommonModule], providers: [
        AuthenticationService,
        TokenStorageService,
        { provide: HTTP_INTERCEPTORS, useClass: AuthenticationErrorInterceptor, multi: true },
        authorizationInterceptorProviders,
        ToastService,
        BaseModalService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    core: CoreModule
  ) {
    if (core) {
      throw new Error('CoreModule already instantiated!');
    }
  }
}
